<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';

const { attachments } = useMessageContext();

const { t } = useI18n();

const attachment = computed(() => {
  return attachments.value[0];
});

const url = computed(() => {
  return attachment.value?.dataUrl;
});

const fileName = computed(() => {
  if (url.value) {
    const cleanUrl = url.value.split(/[?#]/)[0];
    const filename = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
  return t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <BaseAttachmentBubble
    v-if="attachment"
    icon="i-teenyicons-user-circle-solid"
    icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
    :content="decodeURI(fileName)"
    :action="url ? { href: url, label: $t('CONVERSATION.DOWNLOAD') } : null"
  >
    <template #icon>
      <FileIcon :file-type="fileType" class="size-4" />
    </template>
  </BaseAttachmentBubble>
</template>
